export enum RequestConfigTimeout {
	CONNECTION = 'CONNECTION'
}

